import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const Services = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  });
  return (
    <>
      <section className="section bg-grey" data-aos="fade-in">
        <div className="section-title">
          <h2 style={{ marginTop: "1rem" }}>Services</h2>
          <div className="underline"></div>
        </div>
        <div className="section-center services-center" data-aos="fade-in">
          <article className="service s6">
            <div className="ani">
              <i className="fas fa-code service-icon"></i>
            </div>
            <h4>Web Development</h4>
            <div className="underline"></div>
            <p>
              "MERN Stack Application, React Web Application with MangoDb and
              NodeJS. Static Web Sites"
            </p>
          </article>
          <article className="service s1">
            <div className="ani">
              <i className="fab fa-sketch service-icon"></i>
            </div>
            {/* <h4>Web Design</h4>
            <div className="underline"></div>
            <p>
              Web Designing with CSS Grid, Flex & React Styled Components.",
            </p>
          </article>
          <article className="service s2">
            <div className="ani">
              <i class="fas fa-network-wired service-icon"></i>
            </div> */}
            <h4>Network Services</h4>
            <div className="underline"></div>
            <p>
              Cisco Routing & Switching. Cisco ASA, Virtual Private Network,
              DMVPN, anyConnect etc
            </p>
          </article>
          {/* <article className="service s3">
            <div className="ani">
              <i class="fas fa-ad service-icon"></i>
            </div> */}
          {/* <h4>Digital Marketing / Marketing</h4>
            <div className="underline"></div>
            <p>Soon will be Available</p>
          </article>
          <article className="service s4">
            <div className="ani">
              <i class="fas fa-edit service-icon"></i>{" "}
            </div> */}
          {/* <h4>Technical Writing</h4>
            <div className="underline"></div>
            <p>
              Technical writting. Thesis Writing, Research Paper Writing, Proof
              Reading etc
            </p>
          </article> */}
          <article className="service s5" data-aos="fade-in">
            <div className="ani">
              <i class="fas fa-headset service-icon"></i>
            </div>
            <h4>IT Support</h4>
            <div className="underline"></div>
            <p>2nd Line Support, 3rd Line Support. On Site Support.</p>
          </article>
        </div>
      </section>
    </>
  );
};

export default Services;
